/**
 *
 */

export class ShareModel { // 分享
  title: string; // 标题
  banner: string; // 标语提示
  descr: string; // 描述
  thumb: string; // 显示的缩略图
  url: string; // 链接
}



// WEBPACK FOOTER //
// ./src/providers/model/sharemodel.ts